<template>
  <vue-timepicker 
    v-model="selected"
    :format="pickerFormat"
    :input-width="inputWidth"
    :class="['picker-' + pickerSize]"
    :id="inputId"
    close-on-complete
    manual-input
    hide-dropdown
    fixed-dropdown-button
    hide-clear-button
    @focus="onFocus"
    @change="onChange"
  />
</template>

<script>
  import VueTimepicker from 'vue2-timepicker'
  import 'vue2-timepicker/dist/VueTimepicker.css'
export default {
  components: {
    VueTimepicker,
  },
  props: {
    value: {
      type: [Date, Object],
      default: null,
    },
    pickerSize: {
      type: String,
      default: 'md',
    },
    dataType: {
      type: String,
      default: '',
    },
    inputId: {
      type: String,
      default: '',
    }
  },
  watch: {
    value () {
      if(this.value) {
        this.timeToPicker()
      }
    }
  },
  data () {
    return {
      pickerFormat: 'HH:mm',
      pickerData: { HH: '00', mm: '00' },
      selected: { HH: '00', mm: '00' }
    }
  },
  computed: {
    inputWidth () {
      let width
      switch (this.pickerSize) {
        case 'xl':
          width = '200px'
          break;
        case 'full':
          width = '100%'
          break;
        default:
          width = '95px'
          break;
      }
      return width
    }
  },
  created () {
    if(this.value) this.timeToPicker()
  },
  methods: {
    timeToPicker () {
      if(this.dataType === 'date') {
        this.pickerData.HH = ('0' + this.value.getHours()).slice(-2)
        this.pickerData.mm = ('0' + this.value.getMinutes()).slice(-2)
      } else { // duration
        this.pickerData = { HH: ('0' + this.value.HH).slice(-2), mm: ('0' + this.value.mm).slice(-2) }
      }
      this.selected = this.pickerData
    },
    onFocus () {
      if(this.dataType === 'duration') {
        this.$emit('focus-duration', true);
      } else {
        this.$emit('focus-duration', false);
      }
    },
    onChange (eventData) {
      this.emitTime(eventData)
    },
    emitTime (eventData) {
      let outputTime = new Date()

      if(this.value && this.dataType === 'date') outputTime = this.value

      outputTime.setHours(eventData.data.H, eventData.data.m);

      if(this.dataType === 'duration') {
        outputTime = eventData.data
      }

      this.$emit('input', outputTime);
    }
  }
}
</script>

<style lang="scss">
.vue__time-picker {
  display: inline;
  .dropdown { top: calc(1.7em + 2px) !important; }
  &.picker-xl {
    input {
      &.display-time {
        font-size: 30px;
      }
    }
    .dropdown { top: calc(2.2em + 2px) !important; }
  }
  input {
    &.display-time {
      font-size: 20px;
      border: 0px solid #ced4da;
      border-radius: $radiusSm;
      box-shadow: inset 0 1px 1px rgb(0 0 0 / 16%);
    }
  }
  .dropdown ul li:not([disabled]).active {
    background: $colorBrand;
  }
}
.picker-md {
  .dropdown {
    top: calc(1.7em + 2px) !important;
  }
}

</style>

<style lang="scss" scoped>
</style>

